var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcApi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 6.41732H5.58333M8.33333 9.16732V1.83398H11.0833C11.5696 1.83398 12.0359 2.02714 12.3797 2.37096C12.7235 2.71477 12.9167 3.18109 12.9167 3.66732V4.58398C12.9167 5.07021 12.7235 5.53653 12.3797 5.88035C12.0359 6.22416 11.5696 6.41732 11.0833 6.41732H8.33333M15.6667 1.83398V9.16732M5.58333 9.16732V4.12565C5.58333 3.51786 5.34189 2.93497 4.91212 2.5052C4.48235 2.07543 3.89945 1.83398 3.29167 1.83398C2.68388 1.83398 2.10098 2.07543 1.67121 2.5052C1.24144 2.93497 1 3.51786 1 4.12565V9.16732",
    stroke: "#435869",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcApi);
export default __webpack_public_path__ + "static/media/ic-api.d32c040c2c49fd8979406118a7f0a936.svg";
export { ForwardRef as ReactComponent };